import dayjs from "dayjs";

const toDate = (s) => (s ? new Date(s) : null);

export const fromApi = (tabKey, raw = {}) => {
  const boolStr = (v) => (v ? "1" : "0");

  switch (tabKey) {
    /* ---------- Visa ---------- */
    case "visaInfo":
      return {
        /* personal */
        full_name: raw.full_name_as_per_passport || "",
        // date_of_birth: raw.date_of_birth || null,
        // gender: raw.gender || "",
        // nationality: raw.nationality || "",
        // passport_number: raw.passport_number || "",
        // passport_issue: raw.passport_issue_date || null,
        // passport_expiry: raw.expiry_date || null,
        country_of_birth: raw.country_of_birth || "",
        // marital_status: (raw.marital_status || "").toLowerCase(),
        phone: raw.contact_number_phone || "",
        email: raw.contact_number_email || "",
        address: raw.residential_address || "",

        /* travel */
        // visa_type: raw.type_of_visa || null,
        // purpose: raw.purpose_of_travel || "",
        destination_country: raw.destination_country || null,
        destination_country_name: raw.destination_country_name || "",
        expected_travel: raw.expected_travel_date || null,
        expected_return: raw.expected_return_date || null,
        // duration_stay: raw.duration_of_stay ? String(raw.duration_of_stay) : "",
        // travelled_before: raw.have_you_traveled_to_this_country_before
        //   ? "1"
        //   : "0",

        /* work & finance */
        // occupation: raw.occupation || "",
        // employer_name: raw.employer_name || "",
        // employer_address: raw.employer_address || "",
        // monthly_income: raw.monthly_income ? String(raw.monthly_income) : "",

        /* accommodation */
        // hotel_or_host: raw.hotel_booking_or_host_address || "",
        // contact_person_dest:
        //   raw.contact_person_in_destination_country_if_applicable || "",

        /* files */
        files: {
          // bank: raw.bank_statement_for_financial_proof || "",
          passport: raw.passport_copy || "",
          // photo: raw.passport_sized_photograph || "",
          // finproof:
          //   raw.proof_of_financial_means_bank_statement_pay_slips_etc || "",
          // flight: raw.flight_ticket_if_booked || "",
          // invitation: raw.invitation_letter_if_required || "",
          // insurance: raw.travel_insurance_if_required || "",
        },

        /* declaration */
        agree_terms: !!raw.agreeing_to_the_terms_and_conditions,
        signature: raw.digital_or_physical_signature || "",
      };

    /* ---------- Insurance ---------- */
    case "insurance":
      return {
        /* personal */
        full_name: raw.full_name_as_per_passport || "",
        date_of_birth: raw.date_of_birth || null,
        gender: raw.gender || "",
        nationality: raw.nationality || "",
        passport_number: raw.passport_number || "",
        passport_issue: raw.passport_issue_date || null,
        passport_expiry: raw.expiry_date || null,
        marital_status: (raw.marital_status || "").toLowerCase(),
        phone: raw.contact_number_phone || "",
        email: raw.contact_number_email || "",
        address: raw.residential_address || "",

        /* insurance core */
        destination: raw.destination_countrycountries || null,
        destination_name: raw.destination_countrycountries_name || "",
        travel_start: raw.travel_start_date || null,
        travel_end: raw.travel_end_date || null,
        duration_trip: raw.duration_of_trip ? String(raw.duration_of_trip) : "",
        num_travellers: raw.number_of_travelers
          ? String(raw.number_of_travelers)
          : "",
        medical_conditions: raw.pre_existing_medical_conditions || "",

        insurance_type: raw.type_of_insurance || null,
        coverage_type: raw.coverage_type || null,

        /* payment */
        payment_method: raw.payment_method || null,
        billing_address: raw.billing_address || "",
        invoice_required: boolStr(raw.invoice_required),

        /* travel & contact */
        flight_details:
          raw.flight_details_if_applicable || raw.flight_details || "",
        hotel_details:
          raw.hotel_details_if_applicable || raw.hotel_details || "",
        emergency_contact: raw.emergency_contact || "",

        /* files */
        files: {
          passport_copy: raw.passport_copy || "",
          previous_insurance: raw.previous_insurance || "",
          medical_reports: raw.medical_reports || "",
        },

        /* declaration */
        agree_terms: !!raw.agree_terms,
        signature: raw.digital_signature || "",
      };

    /* ---------- IDL ---------- */
    case "IDL":
      return {
        /* personal */
        full_name: raw.full_name_as_per_passport || "",
        date_of_birth: raw.date_of_birth || null,
        gender: raw.gender || "",
        nationality: raw.nationality || "",
        passport_number: raw.passport_number || "",
        phone: raw.contact_number_phone || "",
        email: raw.contact_number_email || "",
        address: raw.residential_address || "",

        /* IDL specifics */
        purpose_of_travel: raw.purpose_of_travel || null,
        destination: raw.destination_countrycountries || null,
        destination_name: raw.destination_countrycountries_name || "",
        travel_start: raw.travel_start_date || null,
        travel_end: raw.travel_end_date || null,

        type_of_license: raw.type_of_license || null,
        existing_license_number:
          raw.existing_driving_license_number_country_of_issuance || "",
        issue_date_domestic: raw.issue_date_of_domestic_driving_license || null,
        expiry_date_domestic:
          raw.expiry_date_of_domestic_driving_license || null,

        /* payment */
        payment_method: raw.payment_method || null,
        billing_address: raw.billing_address || "",
        invoice_required: boolStr(raw.invoice_required),

        /* travel & contact */
        flight_details: raw.flight_details_if_applicable || "",
        hotel_details: raw.hotel_details_if_applicable || "",
        emergency_contact: raw.emergency_contact_person_and_relationship || "",

        /* files */
        files: {
          passport_copy: raw.passport_copy || "",
          license_copy: raw.domestic_driving_license_copy_front_and_back || "",
          photo: raw.passport_sized_photograph || "",
          address_proof: raw.proof_of_address_if_required || "",
          travel_insurance: raw.travel_insurance_if_required || "",
        },

        /* declaration */
        agree_terms: !!raw.declaration_agreeing_to_the_terms_and_conditions,
        signature: raw.digital_or_physical_signature || "",
      };

      /* ---------- Flight ---------- */
    case "flight":
      return {
        /* personal */
        full_name:       raw.full_name_as_per_passport || "",
        date_of_birth:   raw.date_of_birth             || null,
        gender:          raw.gender                    || "",
        nationality:     raw.nationality               || "",
        passport_number: raw.passport_number           || "",
        passport_issue:  raw.passport_issue_date       || null,
        passport_expiry: raw.passport_expiry_date      || null,
        phone:           raw.contact_number_phone      || "",

        hotel_booking  : boolStr(raw.hotel_booking),                 
        hotel_details  : raw.hotel_details || "",

        /* flight */
        destination_airport: raw.destination_airport || "",
        departure_date:      raw.departure_date      || null,
        return_date:         raw.return_date         || null,
        preferred_airline:   raw.preferred_airline   || "",
        flight_class:        raw.preferred_flight_class || null,
        flexible_dates: raw.flexible_travel_dates !== undefined
                        ? String(raw.flexible_travel_dates)  
                        : "",
        num_passengers_adults:   raw.num_of_passengers_adults   || 0,
        num_passengers_children: raw.num_of_passengers_children || 0,
        num_passengers:          (raw.num_of_passengers_adults || 0) + 
                                (raw.num_of_passengers_children || 0),
        ages:                    raw.ages || [],
        special_requests:    raw.special_requests || "",

        /* payment */
        payment_method:  raw.payment_method  || null,
        billing_address: raw.billing_address || "",
        invoice_required: boolStr(raw.invoice_required),

        /* files */
        files:{
          passport_copy:         raw.passport_copy            || "",
          visa_copy:             raw.visa_copy                || "",
          travel_insurance:      raw.travel_insurance         || "",
          special_travel_permits:raw.special_travel_permits  || "",
        },

        /* declaration */
        agree_terms: !!raw.declaration_agreed,
        signature:   raw.digital_or_physical_signature || "",
      };

   /* ---------- Cruise ---------- */   
    case "Cruise":
        return {
          /* personal */
          full_name: raw.full_name_as_per_passport || "",
          date_of_birth: raw.date_of_birth || null,
          gender: raw.gender || "",
          nationality: raw.nationality || "",
          passport_number: raw.passport_number || "",
          phone: raw.contact_number_phone || "",
          email: raw.contact_number_email || "",
          address: raw.residential_address || "",
  
          /* Cruises specifics */
          departure_port: raw.departure_port || null,
          destination_port: raw.destination_port || null,
          destination:raw.destination || null,
          ship_name: raw.cruise_ship_name || "",
          start_date: raw.cruise_start_date || null,
          end_date: raw.cruise_end_date || null,
  
          cabin_type: raw.cabin_type || null,
          number_of_passengers_adults:
            raw.number_of_passengers_adults || 0,
            number_of_passengers_children: raw.number_of_passengers_children || 0,
            infant_num: raw.infant_num || 0,
            ages: raw.ages || [],
            preferred_cruise_line:
            raw.preferred_cruise_line || null,
            special_requests:
            raw.special_requests || null,
          /* payment */
          payment_method: raw.payment_method || null,
          billing_address: raw.billing_address || "",
          invoice_required: boolStr(raw.invoice_required),
  
          /* travel & contact */
          flight_details: raw.flight_details || "",
          contact_person_dest: raw.contact_person_destination || "",

          /* files */
          files: {
            passport_copy: raw.passport_copy || "",
            travel_insurance: raw.travel_insurance || "",
            visa_required: raw.visa_required || "",
            special_permits: raw.special_permits || "",
          },
  
          /* declaration */
          agree_terms: !!raw.agree_terms,
          signature: raw.digital_signature || "",
        };


      /* ---------- privateJet ---------- */   
    case "privateJet":
      
        return {
          /* personal */
          full_name: raw.full_name_as_per_passport || "",
          date_of_birth: raw.date_of_birth || null,
          gender: raw.gender || "",
          nationality: raw.nationality || "",
          passport_number: raw.passport_number || "",
          phone: raw.contact_number || "",
          email: raw.your_email || "",
          address: raw.residential_address || "",
  
          /* privateJet specifics */
          destination:raw.destination || null,
          destination_name:raw.destination_name || null,
          departure_airport: raw.departure_airport_private_jet_terminal_or_airport || null,
          departure_airport_name: raw.departure_airport_private_jet_terminal_or_airport_name || null,
          destination_airport: raw.destination_airport_private_jet_terminal_or_airport || null,
          destination_airport_name: raw.destination_airport_private_jet_terminal_or_airport_name ||null, 
          departure_date: raw.departure_date_and_time || null,
          return_date: raw.return_date_and_time_if_round_trip || null,
  
          type_of_jet: raw.type_of_jet || null,
          number_of_passengers_adults:
            raw.number_of_passengers_adults || 0,
            number_of_passengers_children: raw.number_of_passengers_children || 0,
            ages: raw.ages || [],
            preferred_aircraft:
            raw.preferred_aircraft_if_any || null,
            special_requests:
            raw.special_requests || null,
          /* payment */
          payment_method: raw.payment_method || null,
          billing_address: raw.billing_address || "",
          invoice_required: boolStr(raw.invoice_required),
  
          /* travel & contact */
          hotel_details: raw.hotel_details_if_applicable || "",
          contact_person_dest: raw.contact_person_at_destination_if_applicable || "",

          /* files */
          files: {
            passport_copy: raw.passport_copy || "",
            travel_insurance: raw.travel_insurance_if_required || "",
            special_permits: raw.special_travel_permits_if_applicable || "",
          },
  
          /* declaration */
          agree_terms: !!raw.declaration_agreeing_to_the_terms_and_conditions,
          signature: raw.digital_or_physical_signature || "",
        };

      /* ---------- Tours ---------- */   
      case "Tours": 
        return {
          destination: raw.destination,
          destinationName: raw.destination_name,
          tourPackageName: raw.tour_package_name,
          tourType: raw.tour_type,
          tourDuration: raw.tour_duration,
          preferredTourDate: raw.preferred_tour_dates ? new Date(raw.preferred_tour_dates) : null,
             // أو dayjs(...).toDate()
      
          num_travellers: raw.number_of_travelers ? String(raw.number_of_travelers) : "",
          childrenAges: raw.ages || [],
          specialRequests: raw.special_requests || "", // Direct string (no split)
          paymentMethod: raw.payment_method,
          billingAddress: raw.billing_address,
          invoiceRequired: raw.invoice_required ? "yes" : "no",
          flightDetails: raw.flight_details,
          hotelDetails: raw.hotel_details,
          destinationContact: raw.destination_contact_person,
          files: { passport_copy: raw.passport_copy },
          agreeTerms: raw.declaration_agreed === 1,
          signature: raw.signature,
          fullName: raw.full_name_as_per_passport,
          phone: raw.contact_number_phone,
          nationality: raw.nationality,
          email: raw.email || ""
        };

      /* ---------- Rental Cars ---------- */
      case 'rentalCars':
        return {
          /* Personal */
          full_name: raw.full_name_as_per_passport || '',
          date_of_birth: toDate(raw.date_of_birth),
          gender: raw.gender || '',
          nationality: raw.nationality || '',
          nationality_name: raw.nationality_name || '',
          passport_number: raw.passport_number || '',
          contact_number_phone: raw.contact_number || '',
          email: raw.your_email || '',
          residential_address: raw.residential_address || '',
          
          /* Rental details */
          drop_off_destination: raw.drop_off_destination,
          pickup_destination: raw.pickup_destination,
          drop_off_destination_name: raw.drop_off_destination_name,
          pickup_destination_name: raw.pickup_destination_name,
          pickup_date_and_time: toDate(raw.pickup_date_and_time),
          pickup_location: raw.pickup_location_city_airport_or_rental_office || '',
          drop_off_location: raw.drop_off_location_city_airport_or_rental_office || '',
          drop_off_date_and_time: toDate(raw.drop_off_date_and_time),
          car_type: raw.car_type || '',
          car_rental_company: raw.car_rental_company_if_preferred || '',
          adults: raw.number_of_passengers || 1,
          children: raw.number_of_passengers_children || 0,
          ages: raw.ages || [],
          special_requests: raw.special_requests_child_seat_gps_additional_driver_etc || '',
          
          /* Payment */
          payment_method: raw.payment_method || '',
          billing_address: raw.billing_address || '',
          invoice_required: !!raw.invoice_required,
          
          /* Travel & Contact */
          contact_person_destination: raw.contact_person_at_destination_if_applicable || '',
          flight_details: raw.flight_details_if_applicable || '',
          
          /* Files */
          files: {
            drivers_license_front: raw.driver_s_license_front_and_back || '',
            drivers_license_back: '', // Not in API response
            passport_copy: raw.passport_copy || '',
            credit_card: raw.credit_card_for_security_deposit || '',
            travel_insurance: raw.travel_insurance_if_required || '',
            special_travel_permits: raw.special_travel_permits_if_applicable || '',
          },
          
          /* Declaration */
          agree_terms: !!raw.declaration_agreeing_to_the_terms_and_conditions,
          signature: raw.digital_or_physical_signature || '',
        };



       /* ---------- Euro Rail ---------- */   
      case "euroRail":
        return {
          /* personal */
          full_name: raw.full_name_as_per_passport || "",
          date_of_birth: raw.date_of_birth || null,
          gender: raw.gender || "",
          nationality: raw.nationality || "",
          passport_number: raw.passport_number || "",
          phone: raw.contact_number_phone || "",
          email: raw.contact_number_email || "",
          destination:raw.destination,
          destination_name:raw.destination_name,
  
          /* Euro Rail specifics */
          departure_station: raw.departure_station || null,
          arrival_station: raw.arrival_station || null,
          departure_date: raw.departure_date || null,
          return_date: raw.return_date || null,
  
          train_type: raw.train_type || null,
          class_of_travel: raw.class_of_travel || null,
          number_of_passengers_adults:  raw.number_of_passengers_adults || 0,
          number_of_passengers_children: raw.number_of_passengers_children || 0,
          ages: raw.ages || [],
          preferred_operator: raw.preferred_operator || null,
          special_requests: raw.special_requests || null,
          /* payment */
          payment_method: raw.payment_method || null,
          billing_address: raw.billing_address || "",
          invoice_required: boolStr(raw.invoice_required),
  
          /* travel & contact */
          flight_details: raw.flight_details || "",
          contact_person_dest: raw.contact_person_destination || "",

          /* files */
          files: {
            passport_copy: raw.passport_copy || "",
            travel_insurance: raw.travel_insurance || "",
            visa_required: raw.visa_required || "",
            special_permits: raw.special_permits || "",
          },
  
          /* declaration */
          agree_terms: !!raw.agree_terms,
          signature: raw.digital_signature || "",
        };
    
    /* ---------- default ---------- */
    default:
      return {};
  }
};
